export const typography = {
  fontFamily: ["Noto Sans"].join(","),
  h1: {
    fontSize: "52px",
    fontWeight: "400",
    lineHeight: "65px"
  },
  h2: {
    fontSize: "40px",
    fontWeight: "400",
    lineHeight: "50px"
  },
  h3: {
    fontSize: "32px",
    fontWeight: "400",
    lineHeight: "40px"
  },
  h4: {
    fontSize: "26px",
    fontWeight: "400",
    lineHeight: "33px"
  },
  h5: {
    fontSize: "20px",
    fontWeight: "400",
    lineHeight: "25px"
  },
  body1: {
    fontSize: "16px",
    fontWeight: "400",
    lineHeight: "22px"
  },
  body2: {
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "21px"
  },
  label: {
    fontSize: "12px",
    fontWeight: "400",
    lineHeight: "18px"
  }
};
